import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader} from '../../../../../../components/UI'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {ModuleErrorColumn} from '../../models'

const TableErrorDetail = ({datos}: PropsA) => {
  const columns: Column<ModuleErrorColumn>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama' />,
      accessor: 'Cama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Cama' />,
      accessor: 'EstadoCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Reserva' />,
      accessor: 'EstadoReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Habitación' />,
      accessor: 'Habitacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Huésped' />,
      accessor: 'Huesped',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Reserva' />,
      accessor: 'Reserva',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={datos} columns={columns} showPagination={false} showButtons={false} />
      </KTCard>
    </>
  )
}

interface PropsA {
  datos: ModuleErrorColumn[]
}

const TableErrorDetailWrapper = ({datos}: PropsA) => {
  return (
    <KTableProvider>
      <TableErrorDetail datos={datos} />
    </KTableProvider>
  )
}

export {TableErrorDetailWrapper}
